import { useSelector } from 'react-redux'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { getIsApplePayEnabled } from 'routes/Checkout/checkoutSelectors'

/**
 * Returns true if Apple Pay is supported by browser.
 */
export const useIsApplePayEligible = (): boolean => useSelector(getIsApplePayEnabled) || false

/**
 * Returns true if Apple Pay is supported by browser and feature is enabled.
 */
export const useIsApplePayEnabled = (): boolean => {
  const isApplePayEnabled = useIsApplePayEligible()
  const isFeatureEnabled = useIsOptimizelyFeatureEnabled(
    isApplePayEnabled ? 'beetroots_apple_pay_web_enabled' : null,
  )

  return (isFeatureEnabled && isApplePayEnabled) || false
}
